import { render, staticRenderFns } from "./LeadRelationBar.vue?vue&type=template&id=570de012&scoped=true&"
import script from "./LeadRelationBar.vue?vue&type=script&lang=js&"
export * from "./LeadRelationBar.vue?vue&type=script&lang=js&"
import style0 from "./LeadRelationBar.vue?vue&type=style&index=0&id=570de012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570de012",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
